import React, { useState, useEffect } from 'react'
import styled, { withTheme, createGlobalStyle } from 'styled-components'
import { get } from 'lodash'

import Input from '../input'
import Select from '../select'
import TreeSelect from '../tree-select'
import {
  getCurrentAppStore,
  setCurrentAppStore,
  getCurrentOrgStore,
  setCurrentOrgStore,
  getCurrentOrgTreeStore,
  setCurrentOrgTreeStore,
} from './storage'
import { traverseTree } from '../utils'

const { Group: InputGroup } = Input
const { Option } = Select

// 机构+应用UI
const OrgAppsInputGroup = styled(InputGroup)`
  display: inline-block !important;
  width: auto !important;
  min-width: 260px;
  height: 28px;
  line-height: 28;
  position: relative;
  top: 50%;
  transform: translateY(-50%);

  &.ant-input-group.ant-input-group-compact::before,
  &.ant-input-group.ant-input-group-compact::after {
    content: '';
    display: none;
  }

  .ant-select-selection,
  .ant-select-selection__rendered {
    line-height: 28px;
    height: 28px;
  }
  .ant-select-selection--multiple {
    padding-bottom: 0;
    overflow: auto;
    min-height: 28px;
  }

  .ant-select-selection {
    .hasHeaderTabs & {
      border-radius: 14px;
      font-size: 12px;
      // 删除默认黑色
      // background: #191D29;
      // border: 1px solid rgba(186,189,197,0.60);
      // color: rgba(255,255,255,.8);
      // 统一改为浅色
      background: #fff !important;
      border-color: #c9d2dd !important;
      color: #8b919e !important;

      .ant-select-selection__placeholder,
      .ant-select-search__field__placeholder {
        color: #8b919e;
      }
    }
    // 删除色系差异
    // .tnt-themeS1.hasHeaderTabs & {
    //     background: #fff;
    //     border-color: #c9d2dd;
    //     color: #8b919e;
    // }

    // 删除色系差异
    // .tnt-themeS3.hasHeaderTabs &{
    //     background: ${(props) => `${props.theme.blueBgColor} !important`}; //#1D4295 !important;
    //     color: rgba(255,255,255,0.8);
    //     border-color: rgba(255,255,255,0.5);
    // }
  }

  .ant-select-arrow {
    .hasHeaderTabs & {
      color: #b2becd;
    }
    .tnt-themeS1 & {
      /* color: rgba(255,255,255,.85); */
    }
  }

  .tnt-themeS1 & {
    border-radius: 2px;
  }

  .isInIframe & {
    margin-left: 20px;
  }
`

// 只展示机构
const AppTreeSelect = styled(TreeSelect)`
  min-width: 160px;
  height: 28px;
  line-height: 28;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  .ant-select-selection,
  .ant-select-selection__rendered {
    line-height: 28px;
    height: 28px;
  }
  .ant-select-selection--multiple {
    padding-bottom: 0;
    overflow: auto;
    min-height: 28px;
  }
  .ant-select-selection {
    .hasHeaderTabs & {
      border-radius: 14px;
      font-size: 12px;
      // 删除默认黑色
      // background: #191D29;
      // border: 1px solid rgba(186,189,197,0.60);
      // color: rgba(255,255,255,.8);
      // 统一为浅色
      background: #fff !important;
      border-color: #c9d2dd !important;
      color: #8b919e !important;
    }
    // 不需要区分色系
    // .tnt-themeS1.hasHeaderTabs & {
    //     /* background: #141825; */
    //     /* color: rgba(255,255,255,.85); */
    //     background: #fff;
    //     border-color: #c9d2dd;
    //     color: #8b919e;
    // }

    // .tnt-themeS3.hasHeaderTabs &{
    //     background: ${(props) => `${props.theme.blueBgColor} !important`}; //#1D4295
    //     color: rgba(255,255,255,0.8);
    //     border-color: rgba(255,255,255,0.5);
    // }
  }
  .ant-select-arrow {
    .hasHeaderTabs & {
      color: #b2becd;
    }
    .tnt-themeS1 & {
      /* color: rgba(255,255,255,.85); */
    }
  }

  .tnt-themeS1 & {
    border-radius: 2px;
  }

  .isInIframe & {
    margin-left: 20px;
  }
`

const GlobalStyle = createGlobalStyle`
    .org-tree-select {
        &.ant-select-tree-dropdown .ant-select-dropdown-search{
            padding: 10px;
            .ant-select-search__field{
                padding: 0 7px;
                height:28px;
                line-height: 28px;
            }
        }
        .ant-select-tree {
            margin-top:0;
            padding: 0 10px 0 4px;
            li{
                margin:4px 0 ;
                .ant-select-tree-switcher{
                    height: 30px;
                    line-height: 30px;
                    float: left;
                }
                .ant-select-tree-node-content-wrapper{
                    height: 30px;
                    line-height:30px;
                    padding: 0;
                    border-radius: 0;
                    &.ant-select-tree-node-selected{
                        background: #E7F0FE;
                    }
                }
                .ant-select-tree-node-content-wrapper:hover{
                    background: #E7F0FE;
                }
                .ant-select-tree-title{
                    font-family: PingFangSC-Regular;
                    color: #17233D;
                    padding-left: 4px;
                    padding-right: 4px;
                    display: block;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }
    }
    .org-tree-check-select {
        .ant-select-tree {
            margin-top:0;
            padding: 0 10px 0 4px;
            li{
                margin:4px 0 ;
                .ant-select-tree-switcher{
                    height: 30px;
                    line-height: 30px;
                    vertical-align: top;
                }

                .ant-select-tree-checkbox{
                    vertical-align: super;
                }
                
                .ant-select-tree-node-content-wrapper{
                    height: 30px;
                    line-height:30px;
                    padding: 0;
                    border-radius: 0;
                    &.ant-select-tree-node-selected{
                        background: #E7F0FE;
                    }
                }
                .ant-select-tree-node-content-wrapper:hover{
                    background: #E7F0FE;
                }
                .ant-select-tree-title{
                    font-family: PingFangSC-Regular;
                    color: #17233D;
                    padding-left: 4px;
                    padding-right: 4px;
                    display: block;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }
    }
`

export default withTheme((props) => {
  const {
    orgAppShow,
    selectedOrgKey,
    orgList,
    orgTreeConfig,
    onOrgChange,
    selectedAppKey,
    orgAppList = [],
    onAppChange,
    headerTabs,
  } = props
  const orgListFormatData = traverseTree([orgList], (item) => {
    item.title = item.name
    item.value = item.uuid
    item.key = item.uuid
  })

  // 初始化数据函数
  const getInitialSelected = (selectedKey, currentStore, dataList, type) => {
    const findByKey = (selectedKey) => {
      let find
      traverseTree(dataList, (item) => {
        if (item.key === selectedKey) {
          find = item
          return false
        }
      })
      return find
    }
    const current = findByKey(selectedKey || get(currentStore, 'key'))
    if (type) {
      return current
    }
    return current || dataList[0]
  }
  // 初始化数据函数机构树
  const getInitialSelectedTree = (selecteds, dataList) => {
    if (selecteds.length) {
      return selecteds
    } else {
      const temp = dataList.map((res) => {
        return {
          label: res.title,
          value: res.uuid,
        }
      })
      setCurrentOrgTreeStore(temp)
      return temp
    }
  }

  // 初始化值
  // 机构
  const [selectedOrg, setSelectedOrg] = useState(
    getInitialSelected(selectedOrgKey, getCurrentOrgStore(), orgListFormatData)
  )

  // 机构树
  const [selectedOrgTree, setSelectedOrgTree] = useState(
    getInitialSelectedTree(getCurrentOrgTreeStore(), orgListFormatData)
  )

  // 应用
  const [selectedApp, setSelectedApp] = useState(
    getInitialSelected(selectedAppKey, getCurrentAppStore(), orgAppList, 'default')
  )

  // org变化事件
  const changeOrg = (org = {}) => {
    setSelectedOrg(org)
    setCurrentOrgStore({
      name: org?.name,
      key: org?.key,
      code: org?.code,
    })
    onOrgChange && onOrgChange(org)
  }

  const changeOrgTree = (val = []) => {
    if (!val.length) {
      val = orgListFormatData.map((res) => {
        return {
          label: res.title,
          value: res.uuid,
        }
      })
    }
    setSelectedOrgTree(val)
    setCurrentOrgTreeStore(val)
    onOrgChange && onOrgChange(val)
  }

  // app变化事件
  const changeApp = (app) => {
    setSelectedApp(app)
    setCurrentAppStore(app)
    onAppChange && onAppChange(app)
  }

  useEffect(() => {
    // 监听org机构
    const newOrg = getInitialSelected(selectedOrgKey, getCurrentOrgStore(), orgListFormatData)
    if (newOrg?.key !== selectedOrg?.key) {
      changeOrg(newOrg)
    }

    // 监听应用
    const newApp = getInitialSelected(selectedAppKey, getCurrentAppStore(), orgAppList)
    if (newApp?.key !== selectedApp?.key) {
      changeApp(newApp)
    }
  }, [orgList, selectedOrgKey, selectedAppKey, orgAppList])

  // 如果是多签页的模式 则居右对齐
  let [treeSelectPosition, selectPosition] = [{}, {}]
  if (headerTabs) {
    treeSelectPosition = {
      dropdownPopupAlign: {
        points: ['tr', 'br'],
      },
    }

    selectPosition = {
      dropdownAlign: {
        points: ['tr', 'br'],
      },
    }
  }

  let orgTreeConfigProp = {}
  if (orgTreeConfig) {
    orgTreeConfigProp = {
      dropdownClassName: 'org-tree-check-select',
      treeCheckable: true,
      treeCheckStrictly: true,
      onChange: (val) => {
        changeOrgTree(val)
      },
      value: selectedOrgTree,
      ...orgTreeConfig,
    }
  } else {
    orgTreeConfigProp = {
      dropdownClassName: 'org-tree-select',
      onChange: (orgKey) => {
        let findItem
        traverseTree(orgListFormatData, (node) => {
          if (node.key === orgKey) {
            findItem = node
            return false
          }
        })
        changeOrg(findItem)
      },
      value: get(selectedOrg, 'key'),
    }
  }

  if (!orgAppShow) {
    return (
      <>
        <AppTreeSelect
          placeholder="选择机构"
          searchPlaceholder="机构名称"
          treeNodeFilterProp="title"
          showSearch
          treeData={orgListFormatData}
          treeDefaultExpandAll
          {...treeSelectPosition}
          style={{ width: 160, height: 28, lineHeight: 28 }}
          dropdownStyle={{ maxHeight: 300, overflow: 'auto', width: 320 }}
          {...orgTreeConfigProp}
        />
        <GlobalStyle />
      </>
    )
  }
  return (
    <OrgAppsInputGroup compact>
      <TreeSelect
        placeholder="选择机构"
        searchPlaceholder="机构名称"
        treeNodeFilterProp="title"
        showSearch
        treeData={orgListFormatData}
        treeDefaultExpandAll
        style={{ width: 130, height: 28, lineHeight: 28 }}
        dropdownStyle={{ maxHeight: 300, overflow: 'auto', width: 320 }}
        {...orgTreeConfigProp}
      />
      <GlobalStyle />
      <Select
        placeholder="请选择"
        showSearch
        optionFilterProp="children"
        onChange={(appKey) => {
          changeApp(orgAppList.find(({ key }) => key === appKey))
        }}
        value={get(selectedApp, 'key')}
        style={{ width: 130, height: 28, lineHeight: 28 }}
      >
        {orgAppList.map(({ key, name }) => (
          <Option key={key} value={key} title={name}>
            {name}
          </Option>
        ))}
      </Select>
    </OrgAppsInputGroup>
  )
})
